import React, { useLayoutEffect, useState } from "react";
import { decodeJwtPayload } from "../utils/decodeJwtPayload";

function readStoredBearer(): string {
  return (
    localStorage.getItem("token")?.trim() ||
    sessionStorage.getItem("token")?.trim() ||
    ""
  );
}

function clearMsOrgSessionStorage(): void {
  const keys = ["token", "user", "mslogin_token", "mslogin_user"];
  for (const k of keys) {
    try {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  }
}

/**
 * 企微换票 JWT 带 `msOrgApplicationId`。若用户从 CRM 等其它应用带入 token，
 * 仅「已登录」不足以进入本 H5；须与本构建的 REACT_APP_MSORG_APPLICATION_ID 一致，
 * 否则清会话并整页刷新，交由外层 WecomMsOrgAuthGuard 走本应用 OAuth + 换票。
 */
export const MsOrgApplicationScopeGate: React.FC<{
  expectedApplicationId?: string;
  children: React.ReactNode;
}> = ({ expectedApplicationId, children }) => {
  const expected = (expectedApplicationId ?? "").trim();
  const [ready, setReady] = useState(!expected);

  useLayoutEffect(() => {
    if (!expected) {
      setReady(true);
      return;
    }
    const token = readStoredBearer();
    if (!token) {
      setReady(true);
      return;
    }
    const payload = decodeJwtPayload(token);
    const inJwt = String(payload?.msOrgApplicationId ?? "").trim();
    if (inJwt === expected) {
      setReady(true);
      return;
    }
    clearMsOrgSessionStorage();
    setReady(false);
    const { origin, pathname, search, hash } = window.location;
    window.location.replace(`${origin}${pathname}${search}${hash}`);
  }, [expected]);

  if (!expected) return <>{children}</>;
  if (!ready) {
    return (
      <div style={{ padding: 48, textAlign: "center", color: "#666", fontSize: 15 }}>
        正在按本应用重新鉴权…
      </div>
    );
  }
  return <>{children}</>;
};
